export default abstract class VOBase {
  abstract getValue: () => any
  abstract format: (formatter?: any) => any
  abstract serialize: () => any
  public isEqual(target: VOBase): boolean {
    return this.getValue() === target.getValue()
  }
}
